import React from 'react';
import { Button } from './Button';
import { SparklesIcon, PlayIcon } from 'lucide-react';
export function GradientHero() {
  return <section className="w-full min-h-screen bg-[#0F0F0F] relative overflow-hidden flex items-center" data-id="element-155">
      {/* Animated Gradient Mesh Background */}
      <div className="absolute inset-0" data-id="element-156">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#F1B530] rounded-full mix-blend-multiply filter blur-[128px] opacity-20 animate-blob" data-id="element-157"></div>
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#D09F2B] rounded-full mix-blend-multiply filter blur-[128px] opacity-20 animate-blob animation-delay-2000" data-id="element-158"></div>
        <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-[#A78942] rounded-full mix-blend-multiply filter blur-[128px] opacity-20 animate-blob animation-delay-4000" data-id="element-159"></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 md:px-12 py-20 relative z-10" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <div className="inline-flex items-center gap-2 bg-[#252525]/80 backdrop-blur-md border border-[#F1B530]/30 rounded-full px-6 py-3 mb-8" data-id="element-162">
            <SparklesIcon className="w-4 h-4 text-[#F1B530]" data-id="element-163" />
            <span className="font-['Inter'] text-sm text-[#F5F5F5] font-medium" data-id="element-164">
              AI-Powered Answering Service
            </span>
          </div>

          <h1 className="font-['Poppins'] font-bold text-5xl md:text-7xl lg:text-8xl text-[#F5F5F5] mb-8 leading-tight" data-id="element-165">
            <span className="bg-gradient-to-r from-[#F5F5F5] via-[#F1B530] to-[#F5F5F5] bg-clip-text text-transparent animate-gradient" data-id="element-166">
              Never Miss
            </span>
            <br data-id="element-167" />
            Another Call
          </h1>

          <p className="font-['Inter'] text-xl md:text-2xl text-[#A0A0A0] max-w-3xl mx-auto mb-12 leading-relaxed font-light" data-id="element-168">
            24/7 AI receptionist that answers instantly, captures perfectly, and
            integrates seamlessly with your business.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16" data-id="element-169">
            <Button size="lg" data-id="element-170">Start Free Trial</Button>
            <Button variant="secondary" size="lg" data-id="element-171">
              Watch Demo
            </Button>
          </div>
        </div>

        {/* Floating Demo Card */}
        <div className="max-w-5xl mx-auto" data-id="element-172">
          <div className="bg-[#252525]/60 backdrop-blur-xl border border-[#2A2A2A] rounded-3xl p-8 shadow-2xl" data-id="element-173">
            <div className="aspect-video bg-[#1A1A1A] rounded-2xl flex items-center justify-center relative overflow-hidden" data-id="element-174">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80" alt="Dashboard preview" className="w-full h-full object-cover opacity-60" data-id="element-175" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-176">
                <div className="w-20 h-20 bg-[#F1B530] rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform duration-300 shadow-lg" data-id="element-177">
                  <PlayIcon className="w-8 h-8 text-[#0F0F0F] fill-[#0F0F0F] ml-1" data-id="element-178" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-179">{`
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        @keyframes gradient {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .animate-gradient {
          background-size: 200% auto;
          animation: gradient 3s linear infinite;
        }
      `}</style>
    </section>;
}